import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

export default function AdminReports() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try { const { data } = await adminApi.reports(); setRows(data?.exports || []); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="admin-page" data-testid="admin-reports">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Reports Center</h2>
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={busy}>{busy?"…":"↻ Refresh"}</button>
      </div>
      <table className="admin-table">
        <thead><tr><th>Created</th><th>Session</th><th>Mode</th><th>Audit ID</th><th>Size (KB)</th></tr></thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={i}>
              <td>{r.created_at && new Date(r.created_at).toLocaleString()}</td>
              <td><code>{(r.session_id||"").slice(0,8)}…</code></td>
              <td><span className="rc-pill">{r.mode?.toUpperCase()}</span></td>
              <td><code>{(r.audit_id||"").slice(0,8)}…</code></td>
              <td>{r.size_bytes ? Math.round(r.size_bytes/1024) : "—"}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5} className="oracle-empty" style={{padding:14}}>No PDF exports yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
